import { addDays, subDays } from "date-fns"

import { gaGetClientIdSync } from "utils/analytics"
import {
    FreeSlotsRequestBody,
    AvailableHoursResponse,
} from "modules/BookingCommon/common/interfaces"
import { ServiceType } from "utils/helpers"
import { OfferedService } from "utils/interfaces"
import { preprocessAvailableHours } from "modules/BookingCommon/components/DatePicker/utils"
import { PossibleHoursRecord } from "modules/Booking/common/interfaces"
import { AvailableLocalHours } from "modules/Booking/components/TimeRequestModal/common/interfaces"
import { format, formatToyMd } from "utils/datetime-format-utils"
import { UserAccount } from "utils/UserAccount"
import { httpClient } from "utils/infrastructure/httpClient"

export function fetchHours(
    from: Date,
    daysBetweenFromTo: number,
    psyHashId: string,
    onlyFree: boolean,
    callback: (prop: AvailableLocalHours | undefined) => void,
    selectedService?: OfferedService
) {
    if (selectedService) {
        const options = {
            psy_hash_id: psyHashId,
            from_date: format(subDays(from, 1), "yyyy-MM-dd"),
            to_date: formatToyMd(addDays(from, daysBetweenFromTo)),
            offset_from_utc_minutes: -new Date().getTimezoneOffset(),
            service_type: selectedService ? new ServiceType(selectedService) : null,
            client_data: UserAccount.data,
            ga_client_id: gaGetClientIdSync(),
            for_psychologist: false,
            only_free: onlyFree,
        }

        httpClient
            .post<AvailableHoursResponse>("psychologist/events/available-hours", options)
            .then((data) => {
                if (Object.keys(data).length !== 0) {
                    const slots = preprocessAvailableHours(data)

                    callback(slots)
                } else {
                    callback(undefined)
                }
            })
            .catch(() => {
                callback(undefined)
                console.error("Не загрузилось свободное время")
            })
    }
}

export function getPossibleHours(data: FreeSlotsRequestBody) {
    return httpClient.post<PossibleHoursRecord>("psychologist/events/possible-hours", {
        ...data,
        client_data: UserAccount.data,
        ga_client_id: gaGetClientIdSync(),
    })
}
